import React, { FormHTMLAttributes, forwardRef } from 'react';

export type FormProps = FormHTMLAttributes<HTMLFormElement>;

const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
  return <form ref={ref} {...props} />;
});

export default Form;
